import { useState } from "react";
import { MousePointerClick } from "lucide-react";
import { useDash } from "../../../lib/dash";
import { useDebounced } from "../../../hooks/useDebounced";
import { AccountList } from "./AccountList";
import { AccountPanel } from "./AccountPanel";

export const NO_QUERY = { q: "", role: "", status: "", page: 0 };

export const listPath = ({ q, role, status, page }) => {
  const p = new URLSearchParams();
  if (q.trim()) p.set("q", q.trim());
  if (role) p.set("role", role);
  if (status) p.set("status", status);
  if (page) p.set("page", String(page));
  const s = p.toString();
  return `/accounts${s ? `?${s}` : ""}`;
};

export const PickHint = () => (
  <p data-testid="accounts-pick-hint" className="flex shrink-0 items-center gap-2 rounded-2xl border border-dashed border-border bg-card/60 px-4 py-3 text-[12px] text-muted-foreground">
    <MousePointerClick className="h-4 w-4 shrink-0" /> Pick an account on the left to see its ducks, spend, credits and (for partners) orders.
  </p>
);

// Accounts: the list on the left, the picked account on the right (`aside` while none is picked).
export const AccountsManager = ({ actorRole, aside = <PickHint />, adminEmailsSet }) => {
  const [query, setQuery] = useState(NO_QUERY);
  const [picked, setPicked] = useState(null);
  const q = useDebounced(query.q, 250);
  const list = useDash(listPath({ ...query, q }));
  const invited = (a) => { list.reload(); setPicked(a.id); };
  return (
    <div data-testid="accounts-manager" className="grid gap-3 lg:h-full lg:grid-cols-12 lg:grid-rows-[minmax(0,1fr)]">
      <div className="min-h-0 lg:col-span-7">
        <AccountList list={list} query={query} onQuery={setQuery} picked={picked} onPick={setPicked}
          actorRole={actorRole} onInvited={invited} adminEmailsSet={adminEmailsSet} />
      </div>
      <div className="min-h-0 lg:col-span-5">
        {picked
          ? <AccountPanel key={picked} id={picked} onClose={() => setPicked(null)} onChanged={list.reload} />
          : aside}
      </div>
    </div>
  );
};
